/** Alinhado ao convite por e-mail (API) e a `referrer.service.js` (extOrigin + extMGM). */
export const MGM_EXT_ORIGIN = 'MEMBER_GET_MEMBER';

const MGM_COUNTRY_CODE = import.meta.env.VITE_BASE_PATH.replace(/^\/+|\/+$/g, '').toUpperCase();

export function buildMgmReferralLink(origin, signupPath, memberGetMemberCode) {
	const base = (origin || '').replace(/\/$/, '');
	const path = signupPath.startsWith('/') ? signupPath : `/${signupPath}`;
	if (!memberGetMemberCode) {
		return `${base}${path}`;
	}
	const params = new URLSearchParams();
	params.set('extMGM', String(memberGetMemberCode));
	params.set('extOrigin', MGM_EXT_ORIGIN);
	params.set('utm_source', `${MGM_COUNTRY_CODE}_referral-program`);
	params.set('utm_medium', `${MGM_COUNTRY_CODE}_referral`);

	return `${base}${path}?${params.toString()}`;
}
